type DetailTitlePrefixProps = {
  label: string;
  href?: string;
  nowrap?: boolean;
};

export const DetailTitlePrefix = (_props: DetailTitlePrefixProps): null => null;
